import React, { useEffect, useState, useCallback } from 'react';
import { FaTimes, FaFilter, FaCheck, FaChevronDown, FaChevronUp } from 'react-icons/fa';
import { HiAdjustmentsHorizontal } from 'react-icons/hi2';
import { toast } from 'react-toastify';
import { fetchAllSubCategory, getAllSubCategoriesBasedOnCategories } from '../../helper/category_helper';
import { useParams } from 'react-router-dom';

const FilterSidebar = ({ onFilterChange, onClearFilters, setLoader }) => {
    const params = useParams();

    // Accordion state - only one section open at a time
    const [openSection, setOpenSection] = useState('category');

    // Hardcoded Categories
    const allCategory = [
        { id: 10, name: 'NSQF', value: 'NSQF' },
        { id: 11, name: 'Non NSQF', value: 'NON NSQF' },
    ];

    const [allSubCategory, setAllSubCategory] = useState([]);

    // Hardcoded Levels
    const allLevel = [
        { id: 1, name: 'Level 1' },
        { id: 2, name: 'Level 2' },
        { id: 3, name: 'Level 3' },
        { id: 4, name: 'Level 4' },
        { id: 5, name: 'Level 5' },
        { id: 6, name: 'Other' }
    ];

    const allDuration = [
        { id: 1, name: '1 - 3 Hours', label: '1-3 hrs' },
        { id: 2, name: '1 - 5 Hours', label: '1-5 hrs' },
        { id: 3, name: '1 - 10 Hours', label: '1-10 hrs' },
        { id: 4, name: '1 - 20 Hours', label: '1-20 hrs' },
        { id: 5, name: '1 - 50 Hours', label: '1-50 hrs' },
        { id: 6, name: 'More than 50 Hours', label: '50+ hrs' },
    ];

    // Filter states
    const [categoryFilterArray, setCategoryFilterArray] = useState([]);
    const [subCategoryFilterArray, setSubCategoryFilterArray] = useState([]);
    const [levelFilterArray, setLevelFilterArray] = useState([]);
    const [durationFilterArray, setDurationFilterArray] = useState([]);
    const [showFreeOnly, setShowFreeOnly] = useState(false);

    // Price range slider state
    const [priceRange, setPriceRange] = useState([0, 10000]);
    const MIN_PRICE = 0;
    const MAX_PRICE = 10000;

    // Mobile states
    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    const [isMobile, setIsMobile] = useState(false);

    // Check screen size
    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 992);
        };
        checkMobile();
        window.addEventListener('resize', checkMobile);
        return () => window.removeEventListener('resize', checkMobile);
    }, []);

    // Prevent body scroll when sidebar is open on mobile
    useEffect(() => {
        if (isMobile && isSidebarOpen) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'unset';
        }
        return () => {
            document.body.style.overflow = 'unset';
        };
    }, [isMobile, isSidebarOpen]);

    // Accordion toggle - only one section open
    const toggleSection = (section) => {
        setOpenSection(openSection === section ? null : section);
    };

    const fetchSubCategories = async () => {
        try {
            const data = await fetchAllSubCategory();
            if (data?.success) {
                setAllSubCategory(data?.result);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    const fetchAllSubCategoriesBasedOnCategories = async (array) => {
        try {
            const data = await getAllSubCategoriesBasedOnCategories(array);
            if (data?.success) {
                setAllSubCategory(data?.result);
            } else {
                toast.error(data?.message);
            }
        } catch (error) {
            toast.error(error?.response?.data?.message);
        }
    };

    useEffect(() => {
        initailCategoryFilterSet();
    }, []);

    const initailCategoryFilterSet = () => {
        let type = params.type;
        if (type === "nsqf") {
            setCategoryFilterArray([{ id: 10, name: 'NSQF', description: 'NSQF' }]);
            fetchAllSubCategoriesBasedOnCategories(["NSQF"]);
        } else if (type === "non-nsqf") {
            setCategoryFilterArray([{ id: 11, name: 'NON NSQF', description: 'NON NSQF' }]);
            fetchAllSubCategoriesBasedOnCategories(["NON NSQF"]);
        } else {
            fetchSubCategories();
        }
    };

    const handleCategoryChange = (category) => {
        let updatedArray;
        if (categoryFilterArray.some(item => item.id === category.id)) {
            updatedArray = categoryFilterArray.filter((item) => item.id !== category.id);
        } else {
            updatedArray = [...categoryFilterArray, category];
        }
        setCategoryFilterArray(updatedArray);
        const categoryNames = updatedArray.map(category => category.name);
        if (categoryNames.length > 0) {
            fetchAllSubCategoriesBasedOnCategories(categoryNames);
        } else {
            fetchSubCategories();
        }
        setSubCategoryFilterArray([]);
    };

    const handleSubCategoryChange = (subCategory) => {
        if (subCategoryFilterArray.some(item => item.id === subCategory.id)) {
            setSubCategoryFilterArray(subCategoryFilterArray.filter((item) => item.id !== subCategory.id));
        } else {
            setSubCategoryFilterArray([...subCategoryFilterArray, subCategory]);
        }
    };

    const handleLevelChange = (level) => {
        if (levelFilterArray.some(item => item.id === level.id)) {
            setLevelFilterArray(levelFilterArray.filter((item) => item.id !== level.id));
        } else {
            setLevelFilterArray([...levelFilterArray, level]);
        }
    };

    const handleDurationChange = (durationName) => {
        if (durationFilterArray.includes(durationName)) {
            setDurationFilterArray(durationFilterArray?.filter((name) => name !== durationName));
        } else {
            setDurationFilterArray([...durationFilterArray, durationName]);
        }
    };

    const handleApply = () => {
        // Build filter object and pass to parent (AllCoursePage) for client-side filtering
        const filters = {
            categoryIds: categoryFilterArray.map(c => c.id),
            subCategoryIds: subCategoryFilterArray.map(s => s.id),
            levelIds: levelFilterArray.map(l => l.name),
            durations: durationFilterArray,
            priceRange: priceRange,
            showFreeOnly: showFreeOnly
        };

        if (onFilterChange) {
            onFilterChange(filters);
        }

        if (isMobile) {
            setIsSidebarOpen(false);
        }
    };

    const handleClearFilters = () => {
        setCategoryFilterArray([]);
        setSubCategoryFilterArray([]);
        setLevelFilterArray([]);
        setDurationFilterArray([]);
        setPriceRange([MIN_PRICE, MAX_PRICE]);
        setShowFreeOnly(false);
        fetchSubCategories();

        if (onClearFilters) {
            onClearFilters();
        }
    };

    // Count active filters
    const activeFilterCount = categoryFilterArray.length + subCategoryFilterArray.length +
        levelFilterArray.length + durationFilterArray.length +
        (priceRange[0] > MIN_PRICE || priceRange[1] < MAX_PRICE ? 1 : 0) +
        (showFreeOnly ? 1 : 0);

    // Filter Section Component
    const FilterSection = ({ id, title, isOpen, children, count = 0 }) => (
        <div style={styles.filterSection}>
            <div
                style={styles.sectionHeader}
                onClick={() => toggleSection(id)}
            >
                <div style={styles.headerLeft}>
                    <span style={styles.headerText}>{title}</span>
                    {count > 0 && (
                        <span style={styles.filterCount}>{count}</span>
                    )}
                </div>
                {isOpen ?
                    <FaChevronUp style={styles.arrowIcon} /> :
                    <FaChevronDown style={styles.arrowIcon} />
                }
            </div>
            <div style={{
                ...styles.sectionContent,
                maxHeight: isOpen ? '300px' : '0',
                opacity: isOpen ? 1 : 0,
                padding: isOpen ? '12px 0' : '0',
                overflow: 'hidden',
                transition: 'all 0.3s ease',
            }}>
                {children}
            </div>
        </div>
    );

    // Checkbox Item Component
    const CheckboxItem = ({ checked, onChange, label }) => (
        <label style={styles.checkboxLabel}>
            <div style={styles.checkboxWrapper}>
                <input
                    type="checkbox"
                    style={styles.checkbox}
                    checked={checked}
                    onChange={onChange}
                />
                <span style={{
                    ...styles.customCheckbox,
                    backgroundColor: checked ? '#024076' : '#fff',
                    borderColor: checked ? '#024076' : '#d1d5db',
                }}>
                    {checked && <FaCheck size={10} color="#fff" />}
                </span>
            </div>
            <span style={styles.labelText}>{label}</span>
        </label>
    );

    // Price Range Slider Component
    const PriceSlider = () => {
        const STEP = 100;
        const GAP = 100;

        const handleMinChange = (e) => {
            const value = Math.min(Number(e.target.value), priceRange[1] - GAP);
            setPriceRange([Math.max(MIN_PRICE, value), priceRange[1]]);
        };

        const handleMaxChange = (e) => {
            const value = Math.max(Number(e.target.value), priceRange[0] + GAP);
            setPriceRange([priceRange[0], Math.min(MAX_PRICE, value)]);
        };

        const minPercent = ((priceRange[0] - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;
        const maxPercent = ((priceRange[1] - MIN_PRICE) / (MAX_PRICE - MIN_PRICE)) * 100;

        return (
            <div style={styles.priceSliderContainer}>
                <div style={styles.priceDisplay}>
                    <span style={styles.priceValue}>₹{priceRange[0].toLocaleString('en-IN')}</span>
                    <span style={styles.priceSeparator}>—</span>
                    <span style={styles.priceValue}>
                        ₹{priceRange[1].toLocaleString('en-IN')}{priceRange[1] >= MAX_PRICE ? '+' : ''}
                    </span>
                </div>
                <div style={styles.sliderWrapper}>
                    <div style={styles.sliderTrack}>
                        <div
                            style={{
                                ...styles.sliderRange,
                                left: `${minPercent}%`,
                                width: `${maxPercent - minPercent}%`,
                            }}
                        />
                    </div>
                    <input
                        type="range"
                        min={MIN_PRICE}
                        max={MAX_PRICE}
                        step={STEP}
                        value={priceRange[0]}
                        onChange={handleMinChange}
                        style={styles.sliderInput}
                    />
                    <input
                        type="range"
                        min={MIN_PRICE}
                        max={MAX_PRICE}
                        step={STEP}
                        value={priceRange[1]}
                        onChange={handleMaxChange}
                        style={styles.sliderInput}
                    />
                </div>
                <div style={styles.priceLabels}>
                    <span>₹0</span>
                    <span>₹10,000+</span>
                </div>
            </div>
        );
    };

    const SidebarContent = () => (
        <div style={styles.sidebarContent}>
            {/* Mobile Header */}
            {isMobile && (
                <div style={styles.mobileHeader}>
                    <div style={styles.mobileHeaderLeft}>
                        <HiAdjustmentsHorizontal size={22} color="#024076" />
                        <h3 style={styles.mobileTitle}>Filters</h3>
                    </div>
                    <button
                        style={styles.closeButton}
                        onClick={() => setIsSidebarOpen(false)}
                        aria-label="Close filters"
                    >
                        <FaTimes size={18} />
                    </button>
                </div>
            )}

            {/* Desktop Header */}
            {!isMobile && (
                <div style={styles.desktopHeader}>
                    <div style={styles.headerTitleRow}>
                        <HiAdjustmentsHorizontal size={20} color="#024076" />
                        <h3 style={styles.desktopTitle}>Filters</h3>
                    </div>
                    {activeFilterCount > 0 && (
                        <span style={styles.activeCount}>{activeFilterCount} active</span>
                    )}
                </div>
            )}

            {/* Filter Sections */}
            <div style={styles.filterContainer}>
                {/* Category */}
                <FilterSection
                    id="category"
                    title="Category"
                    isOpen={openSection === 'category'}
                    count={categoryFilterArray.length + (showFreeOnly ? 1 : 0)}
                >
                    {allCategory?.map((category) => (
                        <CheckboxItem
                            key={category.id}
                            checked={categoryFilterArray.some(f => f.id === category.id)}
                            onChange={() => handleCategoryChange(category)}
                            label={category.name}
                        />
                    ))}
                    {/* Free Courses - Special filter */}
                    <CheckboxItem
                        checked={showFreeOnly}
                        onChange={() => setShowFreeOnly(!showFreeOnly)}
                        label="Free Courses"
                    />
                </FilterSection>

                {/* Sub Category */}
                <FilterSection
                    id="subCategory"
                    title="Sub Category"
                    isOpen={openSection === 'subCategory'}
                    count={subCategoryFilterArray.length}
                >
                    {allSubCategory?.length > 0 ? (
                        allSubCategory.map((subCategory) => (
                            <CheckboxItem
                                key={subCategory.id}
                                checked={subCategoryFilterArray.some(f => f.id === subCategory.id)}
                                onChange={() => handleSubCategoryChange(subCategory)}
                                label={subCategory.name}
                            />
                        ))
                    ) : (
                        <p style={styles.emptyText}>Select a category first</p>
                    )}
                </FilterSection>

                {/* Level */}
                <FilterSection
                    id="level"
                    title="Level"
                    isOpen={openSection === 'level'}
                    count={levelFilterArray.length}
                >
                    {allLevel?.map((level) => (
                        <CheckboxItem
                            key={level.id}
                            checked={levelFilterArray.some(f => f.id === level.id)}
                            onChange={() => handleLevelChange(level)}
                            label={level.name}
                        />
                    ))}
                </FilterSection>

                {/* Price Range */}
                <FilterSection
                    id="price"
                    title="Price Range"
                    isOpen={openSection === 'price'}
                    count={priceRange[0] > MIN_PRICE || priceRange[1] < MAX_PRICE ? 1 : 0}
                >
                    <PriceSlider />
                </FilterSection>

                {/* Duration */}
                <FilterSection
                    id="duration"
                    title="Duration"
                    isOpen={openSection === 'duration'}
                    count={durationFilterArray.length}
                >
                    {allDuration?.map((duration) => (
                        <CheckboxItem
                            key={duration.id}
                            checked={durationFilterArray.includes(duration.name)}
                            onChange={() => handleDurationChange(duration.name)}
                            label={duration.label}
                        />
                    ))}
                </FilterSection>
            </div>

            {/* Action Buttons */}
            <div style={styles.actionButtons}>
                <button style={styles.clearButton} onClick={handleClearFilters}>
                    Clear All
                </button>
                <button style={styles.applyButton} onClick={handleApply}>
                    Apply Filters
                </button>
            </div>
        </div>
    );

    return (
        <>
            {/* Mobile Filter Trigger Button */}
            {isMobile && (
                <button
                    style={styles.mobileFilterTrigger}
                    onClick={() => setIsSidebarOpen(true)}
                    aria-label="Open filters"
                >
                    <FaFilter size={16} />
                    <span>Filters</span>
                    {activeFilterCount > 0 && (
                        <span style={styles.triggerBadge}>{activeFilterCount}</span>
                    )}
                </button>
            )}

            {/* Overlay for mobile */}
            {isMobile && isSidebarOpen && (
                <div
                    style={styles.overlay}
                    onClick={() => setIsSidebarOpen(false)}
                />
            )}

            {/* Sidebar */}
            <div style={{
                ...styles.sidebar,
                ...(isMobile ? styles.mobileSidebar : {}),
                ...(isMobile && isSidebarOpen ? styles.mobileSidebarOpen : {}),
            }}>
                <SidebarContent />
            </div>
        </>
    );
};

// Styles
const styles = {
    sidebar: {
        width: '100%',
        height: '100%',
        backgroundColor: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 4px 20px rgba(0, 0, 0, 0.06)',
        border: '1px solid #e5e7eb',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden',
    },
    mobileSidebar: {
        position: 'fixed',
        top: '0',
        left: '-100%',
        width: '85%',
        maxWidth: '340px',
        height: '100vh',
        zIndex: 1300,
        transition: 'left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        borderRadius: '0 16px 16px 0',
        boxShadow: '4px 0 24px rgba(0, 0, 0, 0.15)',
    },
    mobileSidebarOpen: {
        left: '0',
    },
    sidebarContent: {
        height: '100%',
        padding: '20px',
        overflowY: 'auto',
        display: 'flex',
        flexDirection: 'column',
    },
    mobileHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        paddingBottom: '16px',
        borderBottom: '1px solid #e5e7eb',
    },
    mobileHeaderLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    mobileTitle: {
        fontSize: '18px',
        fontWeight: '700',
        color: '#0f172a',
        margin: 0,
    },
    closeButton: {
        background: '#f1f5f9',
        border: 'none',
        cursor: 'pointer',
        color: '#64748b',
        padding: '10px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        borderRadius: '10px',
        transition: 'all 0.2s',
    },
    desktopHeader: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        marginBottom: '20px',
        paddingBottom: '16px',
        borderBottom: '1px solid #e5e7eb',
    },
    headerTitleRow: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    desktopTitle: {
        fontSize: '17px',
        fontWeight: '700',
        color: '#0f172a',
        margin: 0,
    },
    activeCount: {
        fontSize: '12px',
        fontWeight: '600',
        color: '#024076',
        backgroundColor: '#e0f2fe',
        padding: '4px 10px',
        borderRadius: '20px',
    },
    mobileFilterTrigger: {
        display: 'flex',
        alignItems: 'center',
        gap: '8px',
        backgroundColor: '#ffffff',
        color: '#0f172a',
        border: '1px solid #e5e7eb',
        borderRadius: '10px',
        padding: '12px 18px',
        fontSize: '14px',
        fontWeight: '600',
        cursor: 'pointer',
        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.06)',
        transition: 'all 0.2s',
    },
    triggerBadge: {
        backgroundColor: '#024076',
        color: '#fff',
        fontSize: '11px',
        fontWeight: '700',
        padding: '2px 8px',
        borderRadius: '10px',
        marginLeft: '4px',
    },
    overlay: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        backdropFilter: 'blur(4px)',
        zIndex: 1200,
    },
    filterContainer: {
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
    },
    filterSection: {
        borderBottom: '1px solid #f1f5f9',
    },
    sectionHeader: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        cursor: 'pointer',
        padding: '14px 0',
        userSelect: 'none',
    },
    headerLeft: {
        display: 'flex',
        alignItems: 'center',
        gap: '10px',
    },
    headerText: {
        fontSize: '14px',
        fontWeight: '600',
        color: '#1e293b',
    },
    filterCount: {
        fontSize: '11px',
        fontWeight: '700',
        color: '#fff',
        backgroundColor: '#024076',
        padding: '2px 7px',
        borderRadius: '8px',
        minWidth: '18px',
        textAlign: 'center',
    },
    arrowIcon: {
        color: '#94a3b8',
        fontSize: '12px',
        transition: 'transform 0.3s',
    },
    sectionContent: {
        display: 'flex',
        flexDirection: 'column',
        gap: '10px',
    },
    checkboxLabel: {
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        padding: '6px 8px',
        borderRadius: '8px',
        transition: 'background-color 0.2s',
    },
    checkboxWrapper: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        width: '18px',
        height: '18px',
        marginRight: '12px',
    },
    checkbox: {
        opacity: 0,
        position: 'absolute',
        width: '100%',
        height: '100%',
        cursor: 'pointer',
        zIndex: 2,
    },
    customCheckbox: {
        width: '18px',
        height: '18px',
        border: '2px solid #d1d5db',
        borderRadius: '5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s',
        pointerEvents: 'none',
    },
    labelText: {
        fontSize: '13px',
        color: '#475569',
        fontWeight: '500',
        userSelect: 'none',
        flex: 1,
    },
    emptyText: {
        fontSize: '13px',
        color: '#94a3b8',
        fontStyle: 'italic',
        margin: '8px 0',
    },
    // Price Slider Styles
    priceSliderContainer: {
        padding: '8px 0',
    },
    priceDisplay: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        gap: '12px',
        marginBottom: '16px',
    },
    priceValue: {
        fontSize: '15px',
        fontWeight: '700',
        color: '#024076',
        backgroundColor: '#f0f9ff',
        padding: '6px 14px',
        borderRadius: '8px',
    },
    priceSeparator: {
        color: '#94a3b8',
        fontSize: '14px',
    },
    sliderWrapper: {
        position: 'relative',
        height: '24px',
        marginBottom: '8px',
    },
    sliderTrack: {
        position: 'absolute',
        top: '50%',
        transform: 'translateY(-50%)',
        width: '100%',
        height: '6px',
        backgroundColor: '#e2e8f0',
        borderRadius: '3px',
    },
    sliderRange: {
        position: 'absolute',
        height: '100%',
        backgroundColor: '#024076',
        borderRadius: '3px',
    },
    sliderInput: {
        position: 'absolute',
        width: '100%',
        height: '24px',
        top: 0,
        margin: 0,
        padding: 0,
        background: 'transparent',
        pointerEvents: 'auto',
        appearance: 'none',
        WebkitAppearance: 'none',
        cursor: 'pointer',
    },
    priceLabels: {
        display: 'flex',
        justifyContent: 'space-between',
        fontSize: '11px',
        color: '#94a3b8',
        fontWeight: '500',
    },
    // Action Buttons
    actionButtons: {
        display: 'flex',
        gap: '10px',
        marginTop: '20px',
        paddingTop: '16px',
        borderTop: '1px solid #e5e7eb',
    },
    applyButton: {
        flex: 1,
        backgroundColor: '#024076',
        color: '#ffffff',
        padding: '12px',
        borderRadius: '10px',
        border: 'none',
        fontSize: '14px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s',
        boxShadow: '0 2px 8px rgba(2, 64, 118, 0.2)',
    },
    clearButton: {
        flex: 1,
        backgroundColor: '#f8fafc',
        color: '#64748b',
        padding: '12px',
        borderRadius: '10px',
        border: '1px solid #e5e7eb',
        fontSize: '14px',
        fontWeight: '600',
        cursor: 'pointer',
        transition: 'all 0.2s',
    },
};

export default FilterSidebar;